<template>
    <form class="col-md-8 mx-auto" @submit.prevent="onSubmit">
        <div class="loader" v-if="loading"></div>
        <div v-if="!loading">
            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('sideMenu.home') }}
                </button>
            </div>
            <div class="form-row">
                <h1>{{ $t('nipData.title') }} </h1><!-- TODO: -->
            </div>
        </div>
        <div class="card row mt-5">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">{{ $t('nipData.companyData') }}</div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="form-group col-lg-4">
                        <label class="font-weight-bold required" :for="'name' + _uid">{{ $t('company.name') }}</label>
                        <input type="text" class="form-control"
                               v-model="company.name"
                               v-validate="'required'"
                               :data-vv-as="$t('company.name')"
                               :name="'name' + _uid"
                               :id="'name' + _uid">
                        <span class="text-danger" v-if="errors.has('name' + _uid)">{{ errors.first('name' + _uid) }}</span>
                    </div>
                    <div class="form-group col-lg-4">
                        <label class="font-weight-bold required" :for="'vatNumber' + _uid">
                            {{ $t('company.vatNumber') }}
                        </label>
                        <i class="fas fa-search pointer text-primary float-right"
                           data-toggle="tooltip"
                           :title="vatCheckTitle"
                           @click="checkVatNumber">
                        </i>
                        <input type="text" class="form-control"
                               v-model="company.vatNumber"
                               v-validate="'required'"
                               :data-vv-as="$t('company.vatNumber')"
                               :name="'vatNumber' + _uid"
                               :id="'vatNumber' + _uid">
                        <span class="text-danger" v-if="errors.has('vatNumber' + _uid)">{{ errors.first('vatNumber' + _uid) }}</span>
                    </div>
                    <div class="form-group col-lg-4">
                        <label class="font-weight-bold" :for="'bulstatUic' + _uid">{{ $t('company.bulstatUic') }}</label>
                        <input type="text" class="form-control" v-model="company.bulstatUic" :id="'bulstatUic' + _uid">
                    </div>
                    <div class="form-group col-lg-4">
                        <label class="font-weight-bold required" :for="'email' + _uid">{{ $t('email') }}</label>
                        <input type="text" class="form-control"
                               v-model="company.email"
                               v-validate="'required'"
                               :data-vv-as="$t('email')"
                               :name="'email' + _uid"
                               :id="'email' + _uid">
                        <span class="text-danger" v-if="errors.has('email' + _uid)">{{ errors.first('email' + _uid) }}</span>
                    </div>
                    <div class="form-group col-lg-4">
                        <label class="font-weight-bold" :for="'fax' + _uid">{{ $t('company.fax') }}</label>
                        <input type="text" class="form-control" v-model="company.fax" :id="'fax' + _uid">
                    </div>
                    <div class="form-group col-lg-4">
                        <label class="font-weight-bold required" :for="'phone' + _uid">{{ $t('company.phone') }}</label>
                        <input type="text" class="form-control"
                               v-model="company.phone"
                               v-validate="'required'"
                               :data-vv-as="$t('company.phone')"
                               :name="'phone' + _uid"
                               :id="'phone' + _uid">
                        <span class="text-danger" v-if="errors.has('phone' + _uid)">{{ errors.first('phone' + _uid) }}</span>
                    </div>
                    <div class="form-group col-lg-4">
                        <label class="font-weight-bold" :for="'url' + _uid">{{ $t('company.url') }}</label>
                        <input type="text" class="form-control" v-model="company.url" :id="'url' + _uid">
                    </div>
                    <div class="form-group col-lg-12">
                        <label class="font-weight-bold" :for="'description' + _uid">{{ $t('company.description') }}</label>
                        <textarea rows="3" class="form-control" v-model="company.description" :id="'description' + _uid"></textarea>
                    </div>
                </div>
                <br>
                <person :person="company.manager" :title="$t('company.manager')" :requiredIdentification="false"></person>
                <br>
                <person :person="company.contact" :title="$t('company.contact')" :requiredIdentification="false"></person>
                <br>
                <app-address ref="registeredAddress" :address="company.registeredAddress" :title="$t('company.registeredAddress')"></app-address>
                <br>
                <app-address ref="contactAddress" :address="company.contactAddress" :title="$t('company.contactAddress')"></app-address>
                <br>
                <bank-account :bankAccount="company.bankAccount" :title="$t('company.bankAccount')"></bank-account>
            </div>
        </div>
        <div class="text-center mt-2 mb-5">
            <button v-if="hasEditRights" type="button" class="btn btn-primary btn-md mr-2"
                    @click="onSubmit">
                <i class="far fa-save"></i>
                {{ $t('save') }}
            </button>
        </div>
    </form>
</template>

<script>
    import Person from './../../components/person/Person';
    import Address from './../../components/address/Address';
    import BankAccount from './../../components/bankAccount/BankAccount';
    import { Company } from './../../models/models';

    export default {
        components: {
            'person': Person,
            'app-address': Address,
            'bank-account': BankAccount,
        },
        data() {
            return {
                id: null,
                company: new Company(),
                loading: false,
                vatCheckTitle: this.$t('vatCheckTitle')
            }
        },
        methods: {
            onSubmit() {
                if (!this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$validator.validateAll().then(result => {
                    if (result) {
                        if (this.id) {
                            this.edit();
                        } else {
                            this.create();
                        }
                    }
                })
            },
            backToRegister() {
                this.$router.push('/');
            },
            checkVatNumber() {
                this.$http.get('/api/Services/vatNumberCheck/' + this.company.vatNumber)
                    .then(response => {
                        this.$refs.appPopup.show(response.data.isValid === true ? 'success' : "danger",
                            this.$t('vatCheckTitle'),
                            '<div class="text-center">' + response.data.msg + '</div>', true);
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            create() {
                this.loading = true;
                this.$http.post('/api/nipData', this.company).then(result => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorDataNotSaved'),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            edit() {
                this.loading = true;
                this.$http.put('/api/nipData', this.company).then(result => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.success'), // TODO:
                        text: this.$t('notifications.successfulSavedData'), // TODO:
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'), // TODO:
                        text: this.$t('notifications.errorDataNotSaved'), // TODO:
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            loadData() {
                this.loading = true;

                this.$http.get(`/api/nipData/${this.id}`)
                    .then(result => {
                        this.company = new Company(result.data);
                    })
                    .catch(error => {
                        // TODO: Notify
                        console.log(error);
                    })
                    .then(() => { this.loading = false; });
            }
        },
        mounted() {
            this.$http.get('/api/institution/GetDefault')
                .then(result => {
                    if (result.data) {
                        this.id = result.data;
                        this.loadData();
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        computed: {
            hasEditRights() {
                return this.$store.getters.claims.nijData.create
                    || this.$store.getters.claims.nijData.update;
            },
        }
    }
</script>

<style scoped>
</style>
